export default {
  addAnimationClass(selector, className) {
    console.log(selector, className);
    const el = document.querySelector(selector);
    if (!el) return;
    el.classList.add(className);
    function removeClass() {
      el.classList.remove(className);
      el.removeEventListener('animationend', removeClass);
    }
    el.addEventListener('animationend', removeClass);
  },
};



// WEBPACK FOOTER //
// ./src/services/animation-service.js